/**
 * Кастомная иконка «Плюс» для центральной кнопки нижнего меню
 *
 * stroke заменён на currentColor для поддержки окрашивания через Tailwind
 */

interface IconProps {
  className?: string;
  size?: number | string;
}

export function AddIcon({ className, size }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6 12H18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18V6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
